import { render, staticRenderFns } from "./DrivesForm.vue?vue&type=template&id=6b46216f&scoped=true"
import script from "./DrivesForm.vue?vue&type=script&lang=js"
export * from "./DrivesForm.vue?vue&type=script&lang=js"
import style0 from "./DrivesForm.vue?vue&type=style&index=0&id=6b46216f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b46216f",
  null
  
)

export default component.exports